export * from "./usePageName";

declare global {
  interface Window {
    REAPackageVersions?: Record<string, string[]>;
  }
}
if (typeof window === "object") {
  window.REAPackageVersions = window.REAPackageVersions || {};
  window.REAPackageVersions["@rea-argonaut/analytics-react"] =
    window.REAPackageVersions["@rea-argonaut/analytics-react"] || [];
  window.REAPackageVersions["@rea-argonaut/analytics-react"].push(
    "__@rea-argonaut/analytics-react/version__",
  );
}
